import { sortBy, filter } from 'lodash';
import React from 'react';

import { Delete } from '../shared/rowActions/Delete';
import { Edit } from '../shared/rowActions/Edit';
import RelationshipLabelEditor from './RelationshipLabelEditor';
import relationshipLabelsResource from 'src/actions/relationshipLabels/relationshipLabelResource';
import RouterLinkButton from 'src/presentation/components/RouterLinkButton';
import TablePage, { TablePageRender } from '../shared/TablePage';
import useResource, { isLoadingStatus } from 'src/presentation/hooks/useResource';

const dataAidPrefix = 'admin-relationship-labels-';

const columnConfig = [{ attr: 'displayName', label: 'Relationships' }];

function renderRowActions({ item }) {
  return (
    <>
      <Edit id={item.id} />
      <Delete
        confirmationText="Delete this relationship?"
        deleteAction={relationshipLabelsResource.effects.remove}
        description="Deleting this relationship will remove it from customer profiles, and cannot be undone."
        id={item.id}
        submitText="Delete Relationship"
      />
    </>
  );
}

const RelationshipLabels: TablePageRender = ({ root }) => {
  const actions = (
    <RouterLinkButton data-aid={`${dataAidPrefix}addNew`} to={`${root}/new`}>
      Create Relationship
    </RouterLinkButton>
  );
  const description = (
    <span>
      Relationships connect people in Gladly so you can jump between their profiles and share conversations, such as
      when a person asks a question on someone else&apos;s behalf. Relationships can be called, for example, “Spouse”,
      “Executive Assistant”, and so on.&quot;{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/what-is-customer-relationships/">
        Learn more about managing relationships
      </a>
      .
    </span>
  );
  const { errors, loadingState, values } = useResource(relationshipLabelsResource);
  const relationshipLabels = sortBy(values, item => item.displayName.toLowerCase());

  function filterFunc(items, searchString) {
    if (!searchString) {
      return items;
    }
    const results = filter(items, item => {
      return item.displayName.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
    });
    return results;
  }

  return (
    <TablePage
      actions={actions}
      columnConfig={columnConfig}
      editor={RelationshipLabelEditor}
      errors={errors}
      filterFunc={filterFunc}
      isLoading={isLoadingStatus(loadingState)}
      items={relationshipLabels}
      name="Relationships"
      description={description}
      resetErrors={relationshipLabelsResource.actions.resetErrors}
      root={root}
      renderRowActions={renderRowActions}
      data-aid={`${dataAidPrefix}page`}
    />
  );
};

export default RelationshipLabels;
